import { useEffect, useState } from "react";

import Sidebar from "components/Common/SideBar/SideBar";
import LearnPointHeader from "components/Common/Header/Header";
import Grid from "@mui/material/Grid";
import classes from "./LearnPointLayout.module.css";
import Default from "components/Common/Default/Default";
import { useLocation } from "react-router-dom";
import ManageClasses from "components/LearnPoint/ManageClasses/ManageClasses";
import Frameworks from "components/LearnPoint/Framework/Frameworks";
import Admin from "components/LearnPoint/Admin/Admin";
import Jobs from "components/LearnPoint/Jobs/Jobs";
import Classes from "components/LearnPoint/Classess/Classes";
import Requisition from "components/LearnPoint/Requisition/Requisition";
import ClassRoster from "components/LearnPoint/ClassRoster/ClassRoster";
import DtrDetails from "components/LearnPoint/DTR/DtrDetails";

const LearnPointLayout = () => {
  const location = useLocation();
  const [index, setIndex] = useState(0);

  useEffect(() => {
    localStorage.setItem("LPHome", window.location.pathname);
    if (location.pathname === "/learnPoint") setIndex(() => 0);

    if (location.pathname === "/learnpoint/infoSection/manageclasses")
      setIndex(() => 1);

    if (location.pathname === "/learnpoint/infoSection/frameworks") setIndex(2);

    if (location.pathname === "/learnpoint/infoSection/requisition")
      setIndex(3);

    if (location.pathname === "/learnpoint/infoSection/admin") setIndex(4);

    if (location.pathname === "/learnpoint/infoSection/jobs") setIndex(5);

    if (location.pathname === "/learnpoint/infoSection/Classes") setIndex(6);

    if (location.pathname === "/learnpoint/infoSection/ClassRoster")
      setIndex(7);

    if (location.pathname === "/learnpoint/infoSection/dtrDetails") setIndex(8);
  }, [location.pathname, location.state]);

  return (
    <Grid container spacing={2} className={classes.learnPointBody}>
      <Grid item xs={0.75} className={classes.grid}>
        <Sidebar index={index} type="learnpoint" />
      </Grid>
      <Grid item xs={11.25} className={classes.grid}>
        <LearnPointHeader
          title="LearnPoint"
          logoURL="/learnpoint"
          version="new"
        />
        <div className={classes.content}>
          {index === 0 && <Default />}
          {index === 1 && <ManageClasses />}
          {index === 2 && <Frameworks />}
          {index === 3 && <Requisition />}
          {index === 4 && <Admin />}
          {index === 5 && <Jobs />}
          {index === 6 && <Classes />}
          {index === 7 && <ClassRoster />}
          {index === 8 && <DtrDetails />}
        </div>
      </Grid>
    </Grid>
  );
};

export default LearnPointLayout;
